// Strip every non-alphanumeric character and lowercase. Used so that
// "Wide Receiver", "wide-receiver", "WideReceiver", and "WR" can all
// share entries in the resolver alias map.
export function normalizePositionString(input: string): string {
  return input.toLowerCase().replace(/[^a-z0-9]/g, '')
}
